export default __webpack_public_path__ + "static/media/mountain-2.726baf0d.png";